














import { Vue, Component } from "vue-property-decorator";
import SideBarController, { SideBarOption } from "@/controller/side-bar";
import SideBarItem from "./SideBarItem.vue";
import SideBarItemExpandable from "./SideBarItemExpandable.vue";

@Component({
  components: {
    SideBarItem,
    SideBarItemExpandable
  }
})
export default class SideBar extends Vue {
  get options(): SideBarOption[] {
    return this.isAdmin
      ? SideBarController.getSideBarAdminOptions()
      : SideBarController.getSideBarModeratorOptions();
  }

  get isAdmin(): boolean {
    return this.$store.getters["user/isAdmin"];
  }
}
